import { render, staticRenderFns } from "./DeleteDepartmentModal.vue?vue&type=template&id=7c069a61&scoped=true"
import script from "./DeleteDepartmentModal.vue?vue&type=script&lang=js"
export * from "./DeleteDepartmentModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteDepartmentModal.vue?vue&type=style&index=0&id=7c069a61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c069a61",
  null
  
)

export default component.exports